// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"8000a9c2","595":"219d9e5c"}[chunkId] + ".chunk.js";
};